import * as React from 'react';
import { Navigate } from 'react-router';
import { useAccessControl } from '~/common/hooks';
import { AccessDecisionStrategy, FeatureFlagEnum } from '~/common/types';

interface Props {
  roles: Array<string>;
  component: React.ComponentType;
  strategy?: AccessDecisionStrategy;
  features?: Array<FeatureFlagEnum>;
}

const PrivateRoute: React.FC<Props> = ({
  roles,
  component: Component,
  strategy = 'affirmative',
  features,
}) => {
  const acl = useAccessControl();
  const canSee =
    acl.isGranted(roles, strategy) && acl.isEnabledFeatures(features);

  if (!canSee) {
    return <Navigate to={'/'} />;
  }
  return <Component />;
};

export default PrivateRoute;
